module.exports = __webpack_public_path__ + "img/2-2.d60efd6.svg";